module.exports = __webpack_public_path__ + "img/ddb2cbc26d0da3d09a24cbd288b9a218.svg";